import request from "@/plugins/axiosRequest";

const url = "/api/dashboard/v1/orders";

export function fetchList(query) {
  return request({
    url: url,
    method: "get",
    params: query
  });
}

export function fetchOrder(id) {
  return request({
    url: url,
    method: "get",
    params: { id }
  });
}

export function markAsPaid(id) {
  return request({
    url: `${url}/${id}/mark-paid`,
    method: "POST"
  });
}

export function checkBalance(id) {
  return request({
    url: `${url}/${id}/check-balance`,
    method: "POST"
  });
}